import { InferType, object, string } from 'yup'
import type { GenericQuizScreenId } from '@/lib/apis/types'

export const AUTHENTICATION_KEY = 'Authentication' satisfies GenericQuizScreenId
export const MEDICARE_CARD_KEY = 'medicare_card'
export const ASSIGNED_SEX_AT_BIRTH_KEY = 'assigned_sex_at_birth'
export const ASSIGNED_SEX_AT_BIRTH_FEMALE = 'female'

export const SCREEN_OFFSET_PARAM = 'offset'
// A screen's own sub-step, e.g. the IHI step inside the Medicare screen. Back
// leaves the sub-step before leaving the screen, and changing screens clears it.
export const SCREEN_STEP_PARAM = 'step'

export const SignInScreenSchema = object({
  username: string()
    .required('Please enter your email address.')
    .email('Please enter a valid email address.'),
  password: string()
    .required('Please enter your password.')
    .min(8, 'Password must be at least 8 characters long'),
})

export interface SignInScreenValues extends InferType<
  typeof SignInScreenSchema
> {}
